import { GetterTree } from 'vuex';
import { AppState } from '.';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { PublishedApp } from '@/features/apps/shared/models';

export const getters: GetterTree<AppState, AppState> = {
	workspaceId(state: AppState): string {
		return state.currentWorkspace.id;
	},
	workspaces(state: AppState): WorkspaceViewModel[] {
		return state.workspaces;
	},
	currentWorkspace(state: AppState): WorkspaceViewModel {
		return state.currentWorkspace;
	},
	currentApp(state: AppState): PublishedApp | null {
		return state.currentApp;
	},
	error(state: AppState): string {
		return state.error;
	},
	isWorkspaceFeatureEnabled(state: AppState): (key: string, defaultValue?: boolean) => boolean {
		return (featureName, defaultValue) => {
			if (state.currentWorkspace && state.currentWorkspace.features) {
				if (state.currentWorkspace.features[featureName] === undefined) {
					return !!defaultValue;
				}
				return state.currentWorkspace.features[featureName];
			}
			return !!defaultValue;
		};
	},
	hasInstalledApps(state: AppState): boolean {
		return state.installedApps.length !== 0;
	},
	isAppInstalled(state: AppState): (appId: string) => boolean | null {
		return (appId: string) => {
			return state.installedApps!.includes(appId);
		};
	},
	workspaceUsageLimit(state: AppState): (usageLimitType: string) => number {
		return (usageLimitType: string) => {
			if (!state.currentWorkspace || !state.currentWorkspace.usageLimits || !state.currentWorkspace.usageLimits[usageLimitType]) {
				return 0;
			}
			return state.currentWorkspace.usageLimits[usageLimitType];
		};
	}
};
